import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import { useIsWideScreen } from '../contexts/WebsiteContext';
import { useResto } from '../contexts/RestoContext';

const Contact = () => {
  const { restoData } = useResto();
  const isWideScreen = useIsWideScreen();

  const phoneNumber = restoData.phone;

  if (isWideScreen || !phoneNumber) {
    return null;
  }

  return (
    <div className="text-center background-main-color-80" style={{ color: 'rgb(255,255,255)', padding: '5px 0', marginBottom:'5px'}}>
      <FontAwesomeIcon icon={faPhone} style={{ marginRight: '10px' }} />
      {phoneNumber}
    </div>
  );
}

export default Contact;
